<vitamui-dialog-header [subhead]="data.subhead | translate"></vitamui-dialog-header>

<mat-dialog-content>
  <vitamui-dialog-content-with-state state="invalid" [title]="data.title | translate">
    <div class="text normal bold">{{ data.subhead | translate }}</div>
    <div class="text normal">{{ data.message | translate }}</div>
  </vitamui-dialog-content-with-state>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button class="btn primary" [matDialogClose]="true">
    {{ data.cancelLabel | translate }}
  </button>
</mat-dialog-actions>
